import { createTheme } from "@mantine/core";

/**
 * Enterprise EMS palette: deep blue primary with a warm amber accent.
 * Keep this minimal; individual pages should lean on Mantine primitives
 * rather than one-off styling.
 */
export const theme = createTheme({
  primaryColor: "indigo",
  defaultRadius: "md",
  fontFamily:
    "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  headings: {
    fontFamily: "inherit",
    sizes: {
      h1: { fontSize: "1.75rem", fontWeight: "600" },
      h2: { fontSize: "1.375rem", fontWeight: "600" },
      h3: { fontSize: "1.125rem", fontWeight: "600" },
    },
  },
  cursorType: "pointer",
});
